// Where a client keeps small files between sessions (explored maps, the content a world sent, map terrain): the page's
// localStorage (base64, under "ashenheart:"), or memory for bots and tests.
import { fromBase64, toBase64 } from './bytes';
import { log } from './log';

export interface ClientStorage {
  read(name: string): Uint8Array | null;
  write(name: string, data: Uint8Array): void;
}

export class MemoryStorage implements ClientStorage {
  private readonly files = new Map<string, Uint8Array>();
  read(name: string): Uint8Array | null { return this.files.get(name) ?? null; }
  write(name: string, data: Uint8Array): void { this.files.set(name, data.slice()); }
}

export class BrowserStorage implements ClientStorage {
  constructor(private readonly prefix = 'ashenheart:') {}

  read(name: string): Uint8Array | null {
    try {
      const text = localStorage.getItem(this.prefix + name);
      return text ? fromBase64(text) : null;
    } catch { return null; }
  }

  write(name: string, data: Uint8Array): void {
    try { localStorage.setItem(this.prefix + name, toBase64(data)); }
    catch (e) { log.warn(`Could not save ${name}: ${(e as Error).message}`); }
  }
}
